var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.8667C14.8267 13.8667 13.8667 14.8267 13.8667 16C13.8667 17.1734 14.8267 18.1333 16 18.1333C17.1734 18.1333 18.1334 17.1734 18.1334 16C18.1334 14.8267 17.1734 13.8667 16 13.8667Z",
    fill: "#676A71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22.3999C14.8267 22.3999 13.8667 23.3599 13.8667 24.5332C13.8667 25.7066 14.8267 26.6666 16 26.6666C17.1734 26.6666 18.1334 25.7066 18.1334 24.5332C18.1334 23.3599 17.1734 22.3999 16 22.3999Z",
    fill: "#676A71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.59989C17.1734 9.59989 18.1334 8.63989 18.1334 7.46655C18.1334 6.29322 17.1734 5.33325 16 5.33325C14.8267 5.33325 13.8667 6.29322 13.8667 7.46655C13.8667 8.63989 14.8267 9.59989 16 9.59989Z",
    fill: "#676A71"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.86db40ce2105a72c560d39adc0a590c0.svg";
export { ForwardRef as ReactComponent };